import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils.ts";
import { LinkButton } from "@repo/ui/link-button";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { ActionLink } from "@/components/common/actions/actions.component";
import { getI18nString } from "@/lib/utils";
import type { VisualType } from "@/lib/types";
import type { CardData } from "@/components/navigation/navigation.types";
interface CardListItemProps {
  card: CardData;
}
function CardListItemContent(t0) {
  const $ = _c(19);
  const {
    card
  } = t0;
  const t1 = card.visual as VisualType;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      sizes: "(max-width: 768px) 85px, 105px",
      cropAspect: 0.8974358974358975
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <VisualWrapper visual={t1} className="w-full max-w-[85px] tablet:max-w-[105px] aspect-[85/115] tablet:aspect-[105/117] overflow-hidden rounded-sm" visualClassName="h-full w-full" extraImageProps={t2} imgClassName="object-cover" />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== card.headline) {
    t4 = card.headline && <h3 className="typography-body-sm-medium text-text-primary">{card.headline}</h3>;
    $[3] = card.headline;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== card.description) {
    t5 = card.description && <p className="typography-body-xs-regular text-text-secondary line-clamp-2">{card.description}</p>;
    $[5] = card.description;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className="flex flex-col gap-1 md:gap-2 pt-1">{t4}{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== card.action?.text || $[11] !== card.action?.to) {
    t7 = card.action?.to && <LinkButton asChild={true} variant="primary" size="sm" underline={true} className="my-1 self-start"><span>{getI18nString(card.action?.text, "Learn more")}</span></LinkButton>;
    $[10] = card.action?.text;
    $[11] = card.action?.to;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="flex flex-col justify-between flex-1">{t6}{t7}</div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t3 || $[17] !== t8) {
    t9 = <>{t3}{t8}</>;
    $[16] = t3;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
export function CardListItem(t0) {
  const $ = _c(8);
  const {
    card
  } = t0;
  if (card.action?.to) {
    const t1 = card.action.to;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = cn("flex items-stretch gap-2 md:gap-4 rounded-lg transition-colors", "hover:bg-surface-base-secondary");
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] !== card) {
      t3 = <CardListItemContent card={card} />;
      $[1] = card;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== card.action.to || $[4] !== t3) {
      t4 = <ActionLink actionTo={t1} className={t2}>{t3}</ActionLink>;
      $[3] = card.action.to;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    return t4;
  }
  let t1;
  if ($[6] !== card) {
    t1 = <div className="flex items-stretch gap-2 md:gap-4 rounded-lg"><CardListItemContent card={card} /></div>;
    $[6] = card;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}